<template>
  <div class="mb-8">
    <TModalHeading kind="green" class="mb-8">
      <template #title>
        {{ t('views.cottage-contact-whatsapp.form.success.title') }}
      </template>

      <template #body>
        <TText>
          {{ t('views.cottage-contact-whatsapp.form.success.subtitle') }}
        </TText>

        <UButton
          v-if="whatsAppLink"
          size="lg"
          :label="t('views.cottage-contact-whatsapp.form.success.openWhatsapp')"
          class="w-full flex justify-center md:w-auto md:inline-flex mt-6 md:mt-0"
          :to="whatsAppLink"
          external
        />
      </template>
    </TModalHeading>

    <CottageContactWhatsAppRecommended :id="id" class="mb-6" />

    <div class="text-center">
      <UButton
        color="neutral"
        size="lg"
        :label="t('views.cottage-contact-whatsapp.form.success.continue')"
        class="w-full flex justify-center md:w-auto md:inline-flex mt-2"
        @click="goBack()"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
import { browserFetch as fetchRuralityCottageDetailPhones } from '~~/modules/api/rurality/v3/cottages/detail/phones'
import type { CottageContactWhatsAppPageCreateForm } from '../entities/CottageContactWhatsAppPageCreate'

interface propsInterface {
  id: string
  name: string
  formData: CottageContactWhatsAppPageCreateForm
}

const route = useRoute()

const slug = route.params.slug as string
const province = route.params.province as string

const showWhatsAppButton = ref<boolean>(true)
const whatsAppLink = ref<string | undefined>(undefined)

const props = defineProps<propsInterface>()

const formattedMessage = t(
  'views.cottage-contact-whatsapp.form.success.messageWhatsapp',
  {
    cottage: props.name,
    name: props.formData.name,
    phone: props.formData.phone,
    message: props.formData.message,
  },
)

const fetchCottagePhones = async () => {
  const data = await fetchRuralityCottageDetailPhones({
    slug,
    province,
  })

  if (data.success && data.success.data.cottagePhones.length > 0) {
    const mainPhone = data.success.data.cottagePhones[0]
    whatsAppLink.value = routesExternal().whatsapp({
      prefix: mainPhone.prefix,
      phoneNumber: mainPhone.phoneNumber,
      text: formattedMessage,
    })
  } else if (data.error || data.success.data.cottagePhones.length < 0) {
    showWhatsAppButton.value = false
  }
}

const goBack = () => {
  window.history.back()
}

onMounted(async () => {
  if (import.meta.client) {
    await fetchCottagePhones()
    if (whatsAppLink.value) {
      await navigateTo(whatsAppLink.value, {
        external: true,
        open: {
          target: '_blank',
        },
      })
    }
  }
})
</script>
